<div class="search-container">
  <form class="search">
    <button mat-icon-button>
      <mat-icon fontIcon="search"></mat-icon>
    </button>
    <input class="search-input" type="text" placeholder="Chercher un produit" #filter
           (keyup)="searchResults(filter.value)">
  </form>
</div>


<div class="stock-dashboard">
  <div style="flex: 40%">
    <table mat-table [dataSource]="filterData" class="table-container">
      <!-- Position Column -->
      <ng-container matColumnDef="item_name">
        <th mat-header-cell *matHeaderCellDef> Produits</th>
        <td mat-cell *matCellDef="let element"> {{ element.item_name }}</td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="total_quantity">
        <th mat-header-cell *matHeaderCellDef> Quantité actuelle</th>
        <td mat-cell *matCellDef="let element"> {{ format_price(element.total_quantity) }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="minimum_quantity">
        <th mat-header-cell *matHeaderCellDef> Minimum</th>
        <td mat-cell *matCellDef="let element"> {{ format_price(element.minimum_quantity) }}</td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="aggregatedColumns"></tr>
      <tr mat-row
          [ngClass]="isStockLow(row.total_quantity, row.minimum_quantity) ? 'low-stock' : ''"
          *matRowDef="let row; columns: aggregatedColumns;"  (click)="select(row)" class="row-table"></tr>

    </table>
  </div>

  <div *ngIf="isProductDetailOpen" class="detailed-dashboard">
    <table mat-table [dataSource]="selectedStockData" class="table-container">
      <!-- Position Column -->
      <ng-container matColumnDef="item_name">
        <th mat-header-cell *matHeaderCellDef> Produits</th>
        <td mat-cell *matCellDef="let element"> {{ element.item_name }}</td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="location_id">
        <th mat-header-cell *matHeaderCellDef> Location</th>
        <td mat-cell *matCellDef="let element"> {{ element.location_id }}</td>
      </ng-container>

      <ng-container matColumnDef="production_date">
        <th mat-header-cell *matHeaderCellDef> Production</th>
        <td mat-cell *matCellDef="let element"> {{ formatDateToMMDDYYYY(element.production_date) }}</td>
      </ng-container>

      <ng-container matColumnDef="expiration_date">
        <th mat-header-cell *matHeaderCellDef> Expiration</th>
        <td mat-cell *matCellDef="let element"> {{ formatDateToMMDDYYYY(element.expiration_date) }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="actual_quantity">
        <th mat-header-cell *matHeaderCellDef> Quantité actuelle</th>
        <td mat-cell *matCellDef="let element"> {{ format_price(element.actual_quantity) }}</td>
      </ng-container>


      <ng-container matColumnDef="item_id">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon class="icon-button" (click)="sendItemToAdd.emit(element)">add_circle_outline</mat-icon>
          <mat-icon  class="icon-button" (click)="sendItemRetire.emit(element)">remove_circle_outline</mat-icon>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="detailsColumns"></tr>
      <tr mat-row
           [ngClass]="isExpirationAlerted(row.expiration_date, row.threshold_days) ? 'alerted' : '' "
          *matRowDef="let row; columns: detailsColumns;"></tr>
    </table>
    <div class="icon-class" (click)="closeTable()">
      <mat-icon style="font-size: 17px">clear icon</mat-icon>
    </div>
  </div>


</div>
